// src/services/userService.js
import http from './http';
import { wOrgIdMiddleware } from '../utils/commonUtils';
import { OK } from '../utils/constant';

const LabOrderdService = {
  getLabOrder: wOrgIdMiddleware(async (url, labId, mapping_id) => {
    try {
      const response = await http.GET(`${url}labs/${labId}/lab-order?mapping_id=${mapping_id}`);
      if (response.code === 200 && response.data) {
        const data = response.data;
        // API returns paginated shape { data: [...], current_page, ... }; return array for all callers
        return Array.isArray(data) ? data : (data.data ?? []);
      }
      return null;
    } catch (error) {
      // console.error('Error fetching user:', error);
      throw error;
    }
  }, true),

  /** List lab orders with backend pagination, sort, and search (query params: page, perPage, sort_by, sort_order, search_query) */
  getLabOrderList: wOrgIdMiddleware(async (url, labId, queryParams = {}) => {
    try {
      const queryString = new URLSearchParams(queryParams).toString();
      const response = await http.GET(`${url}labs/${labId}/lab-order${queryString ? `?${queryString}` : ''}`);
      if (response.code === 200) {
        return response;
      }
      return null;
    } catch (error) {
      throw error;
    }
  }, true),
  saveLabOrder: wOrgIdMiddleware(async (url = '',labId, data) => {
    try {
      const response = await http.POST(`${url}labs/${labId}/lab-order`, data)
      // console.log('response',response);
      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  }, true),

  updateLabOrder: wOrgIdMiddleware(async (url,labId, id, data) => {
    try {
      const response = await http.PUT(`${url}labs/${labId}/lab-order/${id}`, data);
      // if (response.code === 200 ) {
        return response;
      // }
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error fetching user:', error);
      throw error;
    }
  }),
  deleteLabOrder: wOrgIdMiddleware(async (url, labId,id) => {
    try {
      const response = await http.DELETE(`${url}labs/${labId}/lab-order/${id}`);
      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return null;
      }
      
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error fetching user:', error);
      throw error;
    }
  }),
  getLabOrderById: wOrgIdMiddleware(async (url, labId) => {
    try {
      const response = await http.GET(`${url}lab-order/${labId}`);
      if (response.code === OK) {
        return response.data;
      }
      
    } catch (error) {
      // console.error('Error fetching company:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  }),
  // Child Lab Order Configuration methods
  getChildLabOrderConfigurations: wOrgIdMiddleware(async (url = '', labId, labOrderId) => {
    try {
      const response = await http.GET(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching child lab order configurations:', error);
      return [];
    }
  }, true),

  saveChildLabOrderConfiguration: wOrgIdMiddleware(async (url = '', labId, labOrderId, data) => {
    try {
      const response = await http.POST(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations`, data);
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error saving child lab order configuration:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

  updateChildLabOrderConfiguration: wOrgIdMiddleware(async (url = '', labId, labOrderId, id, data) => {
    try {
      const response = await http.PUT(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations/${id}`, data);
      return response;
    } catch (error) {
      console.error('Error updating child lab order configuration:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

  deleteChildLabOrderConfiguration: wOrgIdMiddleware(async (url = '', labId, labOrderId, id) => {
    try {
      const response = await http.DELETE(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations/${id}`);
      if ((response.code === 200 || response.code === 201)) {
        return response.data || { success: true };
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error deleting child lab order configuration:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

  // Clone lab order
  cloneLabOrder: wOrgIdMiddleware(async (url = '', labId, labOrderId, payload = {}) => {
    try {
      const response = await http.POST(`${url}labs/${labId}/lab-order/${labOrderId}/clone`, payload);
      return response;
    } catch (error) {
      console.error('Error cloning lab order:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

  // Child Lab Order Configuration methods
  getChildLabOrderConfigurations: wOrgIdMiddleware(async (url = '', labId, labOrderId) => {
    try {
      const response = await http.GET(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching child lab order configurations:', error);
      return [];
    }
  }, true),

  saveChildLabOrderConfiguration: wOrgIdMiddleware(async (url = '', labId, labOrderId, data) => {
    try {
      const response = await http.POST(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations`, data);
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error saving child lab order configuration:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

  updateChildLabOrderConfiguration: wOrgIdMiddleware(async (url = '', labId, labOrderId, id, data) => {
    try {
      const response = await http.PUT(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations/${id}`, data);
      return response;
    } catch (error) {
      console.error('Error updating child lab order configuration:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

  deleteChildLabOrderConfiguration: wOrgIdMiddleware(async (url = '', labId, labOrderId, id) => {
    try {
      const response = await http.DELETE(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations/${id}`);
      if ((response.code === 200 || response.code === 201)) {
        return response.data || { success: true };
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error deleting child lab order configuration:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

  // Update child lab order configuration positions (for drag and drop reordering)
  updateChildLabOrderPositions: wOrgIdMiddleware(async (url = '', labId, labOrderId, data) => {
    try {
      const response = await http.PUT(`${url}labs/${labId}/lab-order/${labOrderId}/child-configurations/positions`, data);
      if (response.code === 200) {
        return response.data;
      }
      return response;
    } catch (error) {
      console.error('Error updating child lab order positions:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }, true),

};

export default LabOrderdService;